<template>
  <p> </p>
</template>

<script>
export default {
  name: 'HelloI18n'
}
</script>

<i18n>
{
  "uk": {
    "hello": "Hello i18n in SFC!"
  }
}
</i18n>
